/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
export default {
  es: {
    dictionary: {
      'Words: %0': 'Palabras: %0',
      'Characters: %0': 'Caracteres: %0',
      'Widget toolbar': 'Barra de herramientas del widget',
      'Insert paragraph before block': 'Insertar párrafo antes del bloque',
      'Insert paragraph after block': 'Insertar párrafo después del bloque',
      'Press Enter to type after or press Shift + Enter to type before the widget':
        'Pulse Intro para escribir después o pulse Mayús + Intro para escribir antes del «widget».',
      'Keystrokes that can be used when a widget is selected (for example: image, table, etc.)':
        'Teclas que se pueden utilizar cuando se selecciona un módulo interactivo (por ejemplo: imagen, tabla, etc.)',
      'Insert a new paragraph directly after a widget':
        'Inserta un nuevo párrafo directamente después de un módulo interactivo',
      'Insert a new paragraph directly before a widget':
        'Inserta un nuevo párrafo directamente antes de un módulo interactivo',
      'Move the caret to allow typing directly before a widget':
        'Mueve el cursor para permitir escribir directamente antes de un módulo interactivo',
      'Move the caret to allow typing directly after a widget':
        'Mueve el cursor para permitir escribir directamente después de un módulo interactivo',
      'Move focus from an editable area back to the parent widget':
        'Cambiar el foco de un área editable al widget principal',
      'Upload in progress': 'Subida en progreso',
      Undo: 'Deshacer',
      Redo: 'Rehacer',
      'Rich Text Editor': 'Editor de Texto Enriquecido',
      'Editor editing area: %0': 'Área de edición del editor: %0',
      'Edit block': 'Cuadro de edición',
      'Click to edit block': 'Haz clic para editar el bloque',
      'Drag to move': 'Arrastra para mover',
      Next: 'Siguiente',
      Previous: 'Anterior',
      'Editor toolbar': 'Barra de herramientas de edición',
      'Dropdown toolbar': 'Barra de herramientas desplegable',
      Black: 'Negro',
      'Dim grey': 'Gris oscuro',
      Grey: 'Gris',
      'Light grey': 'Gris claro',
      White: 'Blanco',
      Red: 'Rojo',
      Orange: 'Naranja',
      Yellow: 'Amarillo',
      'Light green': 'Verde claro',
      Green: 'Verde',
      Aquamarine: 'Aguamarina',
      Turquoise: 'Turquesa',
      'Light blue': 'Azul claro',
      Blue: 'Azul',
      Purple: 'Morado',
      'Editor block content toolbar':
        'Barra de herramientas de contenido del bloque del editor',
      'Editor contextual toolbar':
        'Barra de herramientas contextual del editor',
      HEX: 'HEX',
      'No results found': 'No se han encontrado resultados',
      'No searchable items': 'No hay elementos que buscar',
      'Editor dialog': 'Diálogo del editor',
      Close: 'Cerrar',
      'Help Contents. To close this dialog press ESC.':
        'Contenidos de ayuda. Presione ESC para cerrar este cuadro de diálogo.',
      'Below, you can find a list of keyboard shortcuts that can be used in the editor.':
        'A continuación, encontrará una lista de atajos de teclado que se pueden utilizar en el editor.',
      '(may require <kbd>Fn</kbd>)': '(puede requerir <kbd>Fn</kbd>)',
      Accessibility: 'Accesibilidad',
      'Accessibility help': 'Ayuda de accesibilidad',
      'Press %0 for help.': 'Presione %0 para obtener ayuda.',
      'Move focus in and out of an active dialog window':
        'Mueve el foco dentro y fuera de una ventana de diálogo activa',
      MENU_BAR_MENU_FILE: 'Archivo',
      MENU_BAR_MENU_EDIT: 'Editar',
      MENU_BAR_MENU_VIEW: 'Ver',
      MENU_BAR_MENU_INSERT: 'Insertar',
      MENU_BAR_MENU_FORMAT: 'Formato',
      MENU_BAR_MENU_TOOLS: 'Herramientas',
      MENU_BAR_MENU_HELP: 'Ayuda',
      MENU_BAR_MENU_TEXT: 'Texto',
      MENU_BAR_MENU_FONT: 'Fuente',
      'Editor menu bar': 'Barra de menú del editor',
      'Please enter a valid color (e.g. "ff0000").':
        'Introduzca un color válido (p. ej., "ff0000").',
      'Insert table': 'Insertar tabla',
      'Header column': 'Columna de encabezado',
      'Insert column left': 'Insertar columna izquierda',
      'Insert column right': 'Insertar columna derecha',
      'Delete column': 'Eliminar columna',
      'Select column': 'Seleccionar columna',
      Column: 'Columna',
      'Header row': 'Fila de encabezado',
      'Insert row below': 'Insertar fila debajo',
      'Insert row above': 'Insertar fila encima',
      'Delete row': 'Eliminar fila',
      'Select row': 'Seleccionar fila',
      Row: 'Fila',
      'Merge cell up': 'Combinar celda superior',
      'Merge cell right': 'Combinar celda derecha',
      'Merge cell down': 'Combinar celda inferior',
      'Merge cell left': 'Combinar celda izquierda',
      'Split cell vertically': 'Dividir celdas verticalmente',
      'Split cell horizontally': 'Dividir celdas horizontalmente',
      'Merge cells': 'Combinar celdas',
      'Table toolbar': 'Barra de herramientas de tabla',
      'Table properties': 'Propiedades de tabla',
      'Cell properties': 'Propiedades de celda',
      Border: 'Borde',
      Style: 'Estilo',
      Width: 'Ancho',
      Height: 'Altura',
      Color: 'Color',
      Background: 'Fondo',
      Padding: 'Márgenes',
      Dimensions: 'Dimensiones',
      'Table cell text alignment': 'Alineación texto de celda',
      Alignment: 'Alineación',
      'Horizontal text alignment toolbar': 'Alineación horizontal de texto',
      'Vertical text alignment toolbar': 'Alineación vertical de texto',
      'Table alignment toolbar': 'Alineación de tabla',
      None: 'Ninguno',
      Solid: 'Sólido',
      Dotted: 'Línea de puntos',
      Dashed: 'Línea discontinua',
      Double: 'Doble línea',
      Groove: 'Bisel',
      Ridge: 'Marco',
      Inset: 'Incrustación',
      Outset: 'Relieve',
      'Align cell text to the left': 'Alinear texto de celda a la izquierda',
      'Align cell text to the center': 'Centrar texto de celda',
      'Align cell text to the right': 'Alinear texto de celda a la derecha',
      'Justify cell text': 'Justificar texto de celda',
      'Align cell text to the top': 'Alinear texto de celda hacia arriba',
      'Align cell text to the middle': 'Alinear texto de celda al medio',
      'Align cell text to the bottom': 'Alinear texto de celda hacia abajo',
      'Align table to the left': 'Alinear tabla a la izquierda',
      'Center table': 'Centrar tabla',
      'Align table to the right': 'Alinear tabla a la derecha',
      'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".':
        'El color es inválido. Intente con "#FF0000", "rgb(255,0,0)" o "red".',
      'The value is invalid. Try "10px" or "2em" or simply "2".':
        'El valor es inválido. Intente con "10px", "2em" o simplemente "2".',
      'Color picker': 'Selector de color',
      'Enter table caption': 'Ingresar título de tabla',
      'Keystrokes that can be used in a table cell':
        'Teclas que se pueden utilizar en una celda de tabla',
      'Move the selection to the next cell':
        'Mueve la selección a la siguiente celda',
      'Move the selection to the previous cell':
        'Mueve la selección a la celda anterior',
      'Insert a new table row (when in the last cell of a table)':
        'Inserta una nueva fila de la tabla (cuando esté en la última celda de una tabla)',
      'Navigate through the table': 'Navega por la tabla',
      Table: 'Tabla',
      Styles: 'Estilos',
      'Multiple styles': 'Múltiples estilos',
      'Block styles': 'Estilos de bloque',
      'Text styles': 'Estilos de texto',
      'Special characters': 'Caracteres especiales',
      All: 'Todos',
      Arrows: 'Flechas',
      Currency: 'Monedas',
      Latin: 'Latín',
      Mathematical: 'Matemáticas',
      Text: 'Texto',
      'leftwards simple arrow': 'flecha simple hacia la izquierda',
      'rightwards simple arrow': 'flecha simple hacia la derecha',
      'upwards simple arrow': 'flecha simple hacia arriba',
      'downwards simple arrow': 'flecha simple hacia abajo',
      'leftwards double arrow': 'flecha doble hacia la izquierda',
      'rightwards double arrow': 'flecha doble hacia la derecha',
      'upwards double arrow': 'flecha doble hacia arriba',
      'downwards double arrow': 'flecha doble hacia abajo',
      'leftwards dashed arrow': 'flecha punteada hacia la izquierda',
      'rightwards dashed arrow': 'flecha punteada hacia la derecha',
      'upwards dashed arrow': 'flecha punteada hacia arriba',
      'downwards dashed arrow': 'flecha punteada hacia abajo',
      'leftwards arrow to bar': 'flecha hacia la izquierda hasta una barra',
      'rightwards arrow to bar': 'flecha hacia la derecha hasta una barra',
      'upwards arrow to bar': 'flecha hacia arriba hasta una barra',
      'downwards arrow to bar': 'flecha hacia abajo hasta una barra',
      'up down arrow with base': 'flecha hacia arriba y abajo con una base',
      'back with leftwards arrow above':
        '«back» con una flecha hacia la izquierda arriba',
      'end with leftwards arrow above':
        '«end» con una flecha hacia la izquierda arriba',
      'on with exclamation mark with left right arrow above':
        '«on» seguido de un signo de exclamación y con una flecha hacia la izquierda y derecha arriba',
      'soon with rightwards arrow above':
        '«soon» con una flecha hacia la derecha arriba',
      'top with upwards arrow above':
        '«top» con una flecha hacia arriba arriba',
      'Dollar sign': 'Signo del dólar',
      'Euro sign': 'Signo del euro',
      'Yen sign': 'Signo del yen',
      'Pound sign': 'Signo de la libra',
      'Cent sign': 'Signo del centavo',
      'Euro-currency sign': 'Signo de la moneda euro',
      'Colon sign': 'Signo del colón',
      'Cruzeiro sign': 'Signo del cruceiro',
      'French franc sign': 'Signo del franco francés',
      'Lira sign': 'Signo de la lira',
      'Currency sign': 'Signo monetario',
      'Bitcoin sign': 'Signo del bitcóin',
      'Mill sign': 'Signo de milésima',
      'Naira sign': 'Signo de naira',
      'Peseta sign': 'Signo de la peseta',
      'Rupee sign': 'Signo de la rupia',
      'Won sign': 'Signo del won',
      'New sheqel sign': 'Signo del nuevo séquel',
      'Dong sign': 'Signo de dong',
      'Kip sign': 'Signo de kip',
      'Tugrik sign': 'Signo de tugrik',
      'Drachma sign': 'Signo de dracma',
      'German penny sign': 'Signo de centavo alemán',
      'Peso sign': 'Signo del peso',
      'Guarani sign': 'Signo del guaraní',
      'Austral sign': 'Signo de austral',
      'Hryvnia sign': 'Signo de grivna',
      'Cedi sign': 'Signo de cedi',
      'Livre tournois sign': 'Signo de libra tornesa',
      'Spesmilo sign': 'Signo de spesmilo',
      'Tenge sign': 'Signo de tenge',
      'Indian rupee sign': 'Signo de rupia india',
      'Turkish lira sign': 'Signo de lira turca',
      'Nordic mark sign': 'Signo de marco nórdico',
      'Manat sign': 'Signo de manat',
      'Ruble sign': 'Signo del rublo',
      'Latin capital letter a with macron':
        'Letra latina mayúscula «A» con macrón',
      'Latin small letter a with macron':
        'Letra latina minúscula «a» con macrón',
      'Latin capital letter a with breve':
        'Letra latina mayúscula «A» con acento breve',
      'Latin small letter a with breve':
        'Letra latina minúscula «a» con acento breve',
      'Latin capital letter a with ogonek':
        'Letra latina mayúscula «A» con ogonek',
      'Latin small letter a with ogonek':
        'Letra latina minúscula «a» con ogonek',
      'Latin capital letter c with acute':
        'Letra latina mayúscula «C» con acento agudo',
      'Latin small letter c with acute':
        'Letra latina minúscula «c» con acento agudo',
      'Latin capital letter c with circumflex':
        'Letra latina mayúscula «C» con acento circunflejo',
      'Latin small letter c with circumflex':
        'Letra latina minúscula «c» con acento circunflejo',
      'Latin capital letter c with dot above':
        'Letra latina mayúscula «C» con punto superior',
      'Latin small letter c with dot above':
        'Letra latina minúscula «c» con punto superior',
      'Latin capital letter c with caron':
        'Letra latina mayúscula «C» con acento anticircunflejo',
      'Latin small letter c with caron':
        'Letra latina minúscula «c» con acento anticircunflejo',
      'Latin capital letter d with caron':
        'Letra latina mayúscula «D» con acento anticircunflejo',
      'Latin small letter d with caron':
        'Letra latina minúscula «d» con acento anticircunflejo',
      'Latin capital letter d with stroke':
        'Letra latina mayúscula «D» con barra horizontal',
      'Latin small letter d with stroke':
        'Letra latina minúscula «d» con barra horizontal',
      'Latin capital letter e with macron':
        'Letra latina mayúscula «E» con macrón',
      'Latin small letter e with macron':
        'Letra latina minúscula «e» con macrón',
      'Latin capital letter e with breve':
        'Letra latina mayúscula «e» con acento breve',
      'Latin small letter e with breve':
        'Letra latina minúscula «e» con acento breve',
      'Latin capital letter e with dot above':
        'Letra latina mayúscula «E» con punto superior',
      'Latin small letter e with dot above':
        'Letra latina minúscula «e» con punto superior',
      'Latin capital letter e with ogonek':
        'Letra latina mayúscula «E» con ogonek',
      'Latin small letter e with ogonek':
        'Letra latina minúscula «e» con ogonek',
      'Latin capital letter e with caron':
        'Letra latina mayúscula «E» con acento anticircunflejo',
      'Latin small letter e with caron':
        'Letra latina minúscula «e» con acento anticircunflejo',
      'Latin capital letter g with circumflex':
        'Letra latina mayúscula «G» con acento circunflejo',
      'Latin small letter g with circumflex':
        'Letra latina minúscula «g» con acento circunflejo',
      'Latin capital letter g with breve':
        'Letra latina mayúscula «G» con acento breve',
      'Latin small letter g with breve':
        'Letra latina minúscula «g» con acento breve',
      'Latin capital letter g with dot above':
        'Letra latina mayúscula «G» con punto superior',
      'Latin small letter g with dot above':
        'Letra latina minúscula «g» con punto superior',
      'Latin capital letter g with cedilla':
        'Letra latina mayúscula «G» con cedilla',
      'Latin small letter g with cedilla':
        'Letra latina minúscula «g» con cedilla',
      'Latin capital letter h with circumflex':
        'Letra latina mayúscula «H» con acento circunflejo',
      'Latin small letter h with circumflex':
        'Letra latina minúscula «h» con acento circunflejo',
      'Latin capital letter h with stroke':
        'Letra latina mayúscula «H» con barra horizontal',
      'Latin small letter h with stroke':
        'Letra latina minúscula «h» con barra horizontal',
      'Latin capital letter i with tilde':
        'Letra latina mayúscula «I» con tilde',
      'Latin small letter i with tilde': 'Letra latina minúscula «i» con tilde',
      'Latin capital letter i with macron':
        'Letra latina mayúscula «I» con macrón',
      'Latin small letter i with macron':
        'Letra latina minúscula «i» con macrón',
      'Latin capital letter i with breve':
        'Letra latina mayúscula «I» con acento breve',
      'Latin small letter i with breve':
        'Letra latina minúscula «i» con acento breve',
      'Latin capital letter i with ogonek':
        'Letra latina mayúscula «I» con ogonek',
      'Latin small letter i with ogonek':
        'Letra latina minúscula «i» con ogonek',
      'Latin capital letter i with dot above':
        'Letra latina mayúscula «I» con punto superior',
      'Latin small letter dotless i': 'Letra latina minúscula «i» sin punto',
      'Latin capital ligature ij': 'Ligadura latina mayúscula «IJ»',
      'Latin small ligature ij': 'Ligadura latina minúscula «ij»',
      'Latin capital letter j with circumflex':
        'Letra latina mayúscula «J» con acento circunflejo',
      'Latin small letter j with circumflex':
        'Letra latina minúscula «j» con acento circunflejo',
      'Latin capital letter k with cedilla':
        'Letra latina mayúscula «K» con cedilla',
      'Latin small letter k with cedilla':
        'Letra latina minúscula «k» con cedilla',
      'Latin small letter kra': 'Letra latina minúscula «kra»',
      'Latin capital letter l with acute':
        'Letra latina mayúscula «L» con acento agudo',
      'Latin small letter l with acute':
        'Letra latina minúscula «l» con acento agudo',
      'Latin capital letter l with cedilla':
        'Letra latina mayúscula «I» con cedilla',
      'Latin small letter l with cedilla':
        'Letra latina minúscula «l» con cedilla',
      'Latin capital letter l with caron':
        'Letra latina mayúscula «I» con acento anticircunflejo',
      'Latin small letter l with caron':
        'Letra latina minúscula «i» con acento anticircunflejo',
      'Latin capital letter l with middle dot':
        'Letra latina mayúscula «L» con punto medio',
      'Latin small letter l with middle dot':
        'Letra latina minúscula «l» con punto medio',
      'Latin capital letter l with stroke':
        'Letra latina mayúscula «L» con barra diagonal',
      'Latin small letter l with stroke':
        'Letra latina minúscula «l» con barra diagonal',
      'Latin capital letter n with acute':
        'Letra latina mayúscula «N» con acento agudo',
      'Latin small letter n with acute':
        'Letra latina minúscula «n» con acento agudo',
      'Latin capital letter n with cedilla':
        'Letra latina mayúscula «N» con cedilla',
      'Latin small letter n with cedilla':
        'Letra latina minúscula «n» con cedilla',
      'Latin capital letter n with caron':
        'Letra latina mayúscula «n» con acento anticircunflejo',
      'Latin small letter n with caron':
        'Letra latina minúscula «n» con acento anticircunflejo',
      'Latin small letter n preceded by apostrophe':
        'Letra latina minúscula «n» precedida de apóstrofo',
      'Latin capital letter eng': 'Letra latina mayúscula «Eng»',
      'Latin small letter eng': 'Letra latina minúscula «eng»',
      'Latin capital letter o with macron':
        'Letra latina mayúscula «O» con macrón',
      'Latin small letter o with macron':
        'Letra latina minúscula «o» con macrón',
      'Latin capital letter o with breve':
        'Letra latina mayúscula «O» con acento breve',
      'Latin small letter o with breve':
        'Letra latina minúscula «o» con acento breve',
      'Latin capital letter o with double acute':
        'Letra latina mayúscula «O» con doble acento agudo',
      'Latin small letter o with double acute':
        'Letra latina minúscula «o» con doble acento agudo',
      'Latin capital ligature oe': 'Ligadura latina mayúscula «OE»',
      'Latin small ligature oe': 'Ligadura latina minúscula «oe»',
      'Latin capital letter r with acute':
        'Letra latina mayúscula «R» con acento agudo',
      'Latin small letter r with acute':
        'Letra latina minúscula «r» con acento agudo',
      'Latin capital letter r with cedilla':
        'Letra latina mayúscula «R» con cedilla',
      'Latin small letter r with cedilla':
        'Letra latina minúscula «r» con cedilla',
      'Latin capital letter r with caron':
        'Letra latina mayúscula «R» con acento anticircunflejo',
      'Latin small letter r with caron':
        'Letra latina minúscula «r» con acento anticircunflejo',
      'Latin capital letter s with acute':
        'Letra latina mayúscula «S» con acento agudo',
      'Latin small letter s with acute':
        'Letra latina minúscula «s» con acento agudo',
      'Latin capital letter s with circumflex':
        'Letra latina mayúscula «S» con acento circunflejo',
      'Latin small letter s with circumflex':
        'Letra latina minúscula «s» con acento circunflejo',
      'Latin capital letter s with cedilla':
        'Letra latina mayúscula «S» con cedilla',
      'Latin small letter s with cedilla':
        'Letra latina minúscula «s» con cedilla',
      'Latin capital letter s with caron':
        'Letra latina mayúscula «S» con acento anticircunflejo',
      'Latin small letter s with caron':
        'Letra latina minúscula «s» con acento anticircunflejo',
      'Latin capital letter t with cedilla':
        'Letra latina mayúscula «T» con cedilla',
      'Latin small letter t with cedilla':
        'Letra latina minúscula «t» con cedilla',
      'Latin capital letter t with caron':
        'Letra latina mayúscula «T» con acento anticircunflejo',
      'Latin small letter t with caron':
        'Letra latina minúscula «t» con acento anticircunflejo',
      'Latin capital letter t with stroke':
        'Letra latina mayúscula «T» con barra horizontal',
      'Latin small letter t with stroke':
        'Letra latina minúscula «t» con barra horizontal',
      'Latin capital letter u with tilde':
        'Letra latina mayúscula «U» con tilde',
      'Latin small letter u with tilde': 'Letra latina minúscula «u» con tilde',
      'Latin capital letter u with macron':
        'Letra latina mayúscula «U» con macrón',
      'Latin small letter u with macron':
        'Letra latina minúscula «u» con macrón',
      'Latin capital letter u with breve':
        'Letra latina mayúscula «U» con acento breve',
      'Latin small letter u with breve':
        'Letra latina minúscula «u» con acento breve',
      'Latin capital letter u with ring above':
        'Letra latina mayúscula «U» con anillo superior',
      'Latin small letter u with ring above':
        'Letra latina minúscula «u» con anillo superior',
      'Latin capital letter u with double acute':
        'Letra latina mayúscula «U» con doble acento agudo',
      'Latin small letter u with double acute':
        'Letra latina minúscula «u» con doble acento agudo',
      'Latin capital letter u with ogonek':
        'Letra latina mayúscula «U» con ogonek',
      'Latin small letter u with ogonek':
        'Letra latina minúscula «u» con ogonek',
      'Latin capital letter w with circumflex':
        'Letra latina mayúscula «W» con acento circunflejo',
      'Latin small letter w with circumflex':
        'Letra latina minúscula «w» con acento circunflejo',
      'Latin capital letter y with circumflex':
        'Letra latina mayúscula «Y» con acento circunflejo',
      'Latin small letter y with circumflex':
        'Letra latina minúscula «y» con acento circunflejo',
      'Latin capital letter y with diaeresis':
        'Letra latina mayúscula «Y» con diéresis',
      'Latin capital letter z with acute':
        'Letra latina mayúscula «Z» con acento agudo',
      'Latin small letter z with acute':
        'Letra latina minúscula «z» con acento agudo',
      'Latin capital letter z with dot above':
        'Letra latina mayúscula «Z» con punto superior',
      'Latin small letter z with dot above':
        'Letra latina minúscula «z» con punto superior',
      'Latin capital letter z with caron':
        'Letra latina mayúscula «Z» con acento anticircunflejo',
      'Latin small letter z with caron':
        'Letra latina minúscula «z» con acento anticircunflejo',
      'Latin small letter long s': 'Letra latina minúscula «s» larga',
      'Less-than sign': 'Signo de menor que',
      'Greater-than sign': 'Signo de mayor que',
      'Less-than or equal to': 'Menor que o igual a',
      'Greater-than or equal to': 'Mayor que o igual a',
      'En dash': 'Semirraya',
      'Em dash': 'Raya',
      Macron: 'Macrón',
      Overline: 'Línea alta',
      'Degree sign': 'Signo de grado',
      'Minus sign': 'Signo de resta',
      'Plus-minus sign': 'Signo más-menos',
      'Division sign': 'Signo de división',
      'Fraction slash': 'Barra fraccionaria',
      'Multiplication sign': 'Signo de multiplicación',
      'Latin small letter f with hook': 'Letra latina minúscula «f» con gancho',
      Integral: 'Integral',
      'N-ary summation': 'Sumatoria',
      Infinity: 'Infinito',
      'Square root': 'Raíz cuadrada',
      'Tilde operator': 'Operador de tilde',
      'Approximately equal to': 'Aproximadamente igual a',
      'Almost equal to': 'Casi igual a',
      'Not equal to': 'No igual a',
      'Identical to': 'Idéntico a',
      'Element of': 'Elemento de',
      'Not an element of': 'No es un elemento de',
      'Contains as member': 'Contiene como miembro',
      'N-ary product': 'Productorio',
      'Logical and': 'Y lógico',
      'Logical or': 'O lógico',
      'Not sign': 'Signo de negación',
      Intersection: 'Intersección',
      Union: 'Unión',
      'Partial differential': 'Diferencial parcial',
      'For all': 'Para todo',
      'There exists': 'Existe',
      'Empty set': 'Conjunto vacío',
      Nabla: 'Nabla',
      'Asterisk operator': 'Operador asterisco',
      'Proportional to': 'Proporcional a',
      Angle: 'Ángulo',
      'Vulgar fraction one quarter': 'Fracción ordinaria de un cuarto',
      'Vulgar fraction one half': 'Fracción ordinaria de un medio',
      'Vulgar fraction three quarters': 'Fracción ordinaria de tres cuartos',
      'Single left-pointing angle quotation mark':
        'Comilla tipográfica simple angular de apertura',
      'Single right-pointing angle quotation mark':
        'Comilla tipográfica simple angular de cierre',
      'Left-pointing double angle quotation mark':
        'Comilla tipográfica doble angular de apertura',
      'Right-pointing double angle quotation mark':
        'Comilla tipográfica dobe angular de cierre',
      'Left single quotation mark': 'Comilla tipográfica de apertura',
      'Right single quotation mark': 'Comilla tipográfica de cierre',
      'Left double quotation mark': 'Comilla tipográfica doble de apertura',
      'Right double quotation mark': 'Comilla tipográfica de cierre',
      'Single low-9 quotation mark':
        'Comilla tipográfica en forma de 9 simple y baja',
      'Double low-9 quotation mark':
        'Comilla tipográfica en forma de 9 doble y baja',
      'Inverted exclamation mark': 'Signo de exclamación de apertura',
      'Inverted question mark': 'Signo de interrogación de apertura',
      'Two dot leader': 'Punto de inicio doble',
      'Horizontal ellipsis': 'Puntos suspensivos horizontales',
      'Double dagger': 'Cruz doble',
      'Per mille sign': 'Signo de por mil',
      'Per ten thousand sign': 'Signo de por diez mil',
      'Double exclamation mark': 'Signo de exclamación doble',
      'Question exclamation mark': 'Signo de exclamación interrogativa',
      'Exclamation question mark': 'Signo de interrogación exclamativa',
      'Double question mark': 'Signo de interrogación doble',
      'Copyright sign': 'Signo de derechos de autor',
      'Registered sign': 'Signo de marca registrada',
      'Trade mark sign': 'Signo de marca comercial',
      'Section sign': 'Signo de sección',
      'Paragraph sign': 'Signo de párrafo',
      'Reversed paragraph sign': 'Signo de antígrafo invertido',
      'Character categories': 'Categorías de caracteres',
      Source: 'Origen',
      'Show source': 'Mostrar fuente',
      'Show blocks': 'Mostrar bloques',
      'Select all': 'Seleccionar todo',
      'Disable editing': 'Inhabilitar edición',
      'Enable editing': 'Habilitar edición',
      'Previous editable region': 'Anterior zona editable',
      'Next editable region': 'Siguiente zona editable',
      'Navigate editable regions': 'Navegar por las zonas editables',
      'Remove Format': 'Quitar Formato',
      'Page break': 'Salto de página',
      'media widget': 'Widget de contenido multimedia',
      'Media URL': 'URL del contenido multimedia',
      'Paste the media URL in the input.':
        'Pega la URL del contenido multimedia',
      'Tip: Paste the URL into the content to embed faster.':
        'Tip: pega la URL dentro del contenido para embeber más rápido',
      'The URL must not be empty.': 'La URL no debe estar vacía',
      'This media URL is not supported.':
        'La URL de este contenido multimedia no está soportada',
      'Insert media': 'Insertar contenido multimedia',
      Media: 'Multimedia',
      'Media toolbar': 'Barra de herramientas de contenido multimedia',
      'Open media in new tab': 'Abrir medio en una pestaña nueva',
      'Numbered List': 'Lista numerada',
      'Bulleted List': 'Lista con viñetas',
      'To-do List': 'Lista de tareas',
      'Bulleted list styles toolbar': 'Estilos de lista con viñetas',
      'Numbered list styles toolbar': 'Estilos de lista numerada',
      'Toggle the disc list style': 'Cambiar estilo de viñeta a disco',
      'Toggle the circle list style': 'Cambiar estilo de viñeta a círculo',
      'Toggle the square list style': 'Cambiar estilo de viñeta a cuadrado',
      'Toggle the decimal list style': 'Cambiar estilo de lista a decimal',
      'Toggle the decimal with leading zero list style':
        'Cambiar estilo de lista decimal empezando con cero',
      'Toggle the lower–roman list style':
        'Cambiar estilo de lista a números romanos en minúsculas',
      'Toggle the upper–roman list style':
        'Cambiar estilo de lista a números roanos en mayúsculas',
      'Toggle the lower–latin list style':
        'Cambiar estilo de lista a números latinos en minúsculas',
      'Toggle the upper–latin list style':
        'Cambiar estilo de lista a números latinos en mayúsculas',
      Disc: 'Disco',
      Circle: 'Círculo',
      Square: 'Cuadrado',
      Decimal: 'Decimal',
      'Decimal with leading zero': 'Decimal con cero',
      'Lower–roman': 'Romanos minúsculas',
      'Upper-roman': 'Romanos mayúscula',
      'Lower-latin': 'Latinos minúsculas',
      'Upper-latin': 'Latinos minúsculas',
      'List properties': 'Propiedades de la lista',
      'Start at': 'Empezar en',
      'Invalid start index value.': 'Valor de índice de inicio no válido.',
      'Start index must be greater than 0.':
        'El número de inicio debe ser mayor que 0.',
      'Reversed order': 'Orden inverso',
      'Keystrokes that can be used in a list':
        'Teclas que se pueden utilizar en una lista',
      'Increase list item indent':
        'Aumenta la sangría de los elementos de la lista',
      'Decrease list item indent':
        'Reduce la sangría de los elementos de la lista',
      'Entering a to-do list': 'Ingresando lista de tareas pendientes',
      'Leaving a to-do list': 'Abandonando lista de tareas pendientes',
      Unlink: 'Quitar enlace',
      Link: 'Enlace',
      'Link URL': 'URL del enlace',
      'Link URL must not be empty.': 'La URL del enlace no puede estar vacía.',
      'Link image': 'URL de la imagen',
      'Edit link': 'Editar enlace',
      'Open link in new tab': 'Abrir enlace en una pestaña nueva',
      'This link has no URL': 'Este enlace no tiene URL',
      'Open in a new tab': 'Abrir en una pestaña nueva ',
      Downloadable: 'Descargable',
      'Create link': 'Crea un enlace',
      'Move out of a link': 'Sale de un enlace',
      Language: 'Idioma',
      'Choose language': 'Elija el idioma',
      'Remove language': 'Quitar idioma',
      'Increase indent': 'Aumentar sangría',
      'Decrease indent': 'Disminuir sangría',
      'image widget': 'Widget de imagen',
      'Wrap text': 'Mantener texto unido',
      'Break text': 'Permitir quebrar texto',
      'In line': 'En línea',
      'Side image': 'Imagen lateral',
      'Full size image': 'Imagen a tamaño completo',
      'Left aligned image': 'Imagen alineada a la izquierda',
      'Centered image': 'Imagen centrada',
      'Right aligned image': 'Imagen alineada a la derecha',
      'Change image text alternative':
        'Cambiar el texto alternativo de la imagen',
      'Text alternative': 'Texto alternativo',
      'Enter image caption': 'Introducir título de la imagen',
      'Insert image': 'Insertar imagen',
      'Replace image': 'Reemplazar imagen',
      'Upload from computer': 'Subir desde el ordenador',
      'Replace from computer': 'Reemplazar desde el ordenador',
      'Upload image from computer': 'Subir imagen desde el ordenador',
      'Image from computer': 'Imagen del ordenador',
      'From computer': 'Desde el ordenador',
      'Replace image from computer': 'Reemplazar imagen del ordenador',
      'Upload failed': 'Fallo en la subida',
      'Image toolbar': 'Barra de herramientas de imagen',
      'Resize image': 'Redimensionar imagen',
      'Resize image to %0': 'Redimensionar imagen al %0',
      'Resize image to the original size':
        'Redimensionar imagen al tamaño original',
      'Resize image (in %0)': 'Cambiar tamaño de la imagen (en un %0)',
      Original: 'Original',
      'Custom image size': 'Personalizar tamaño de imagen',
      Custom: 'Personalizar',
      'Image resize list': 'Listado para redimensionar imagen',
      'Insert image via URL': 'Insertar imagen vía URL',
      'Insert via URL': 'Insertar mediante URL',
      'Image via URL': 'Imagen mediante URL',
      'Via URL': 'Mediante URL',
      'Update image URL': 'Actualizar imagen vía URL',
      'Caption for the image': 'Descripción de la imagen',
      'Caption for image: %0': 'Título de la imagen: %0',
      'The value must not be empty.': 'El valor no puede estar vacío.',
      'The value should be a plain number.':
        'El valor debe ser un número simple.',
      'Uploading image': 'Cargando imagen',
      'Image upload complete': 'Carga de imagen completa',
      'Error during image upload': 'Error durante la carga de la imagen',
      Image: 'Imagen',
      'HTML object': 'Objeto HTML',
      'Insert HTML': 'Insertar HTML',
      'HTML snippet': 'Fragmento HTML',
      'Paste raw HTML here...': 'Pegue el código HTML aquí…',
      'Edit source': 'Editar fuente',
      'Save changes': 'Guardar cambios',
      'No preview available': 'No hay ninguna previsualización',
      'Empty snippet content': 'Fragmento vacío',
      'Horizontal line': 'Línea horizontal',
      'Yellow marker': 'Marcador amarillo',
      'Green marker': 'Marcador verde',
      'Pink marker': 'Marcador rosa',
      'Blue marker': 'Marcador azul',
      'Red pen': 'Texto rojo',
      'Green pen': 'Texto verde',
      'Remove highlight': 'Quitar resaltado',
      Highlight: 'Resaltar',
      'Text highlight toolbar': 'Barra de herramientas de resaltado de texto',
      Paragraph: 'Párrafo',
      Heading: 'Encabezado',
      'Choose heading': 'Elegir Encabezado',
      'Heading 1': 'Encabezado 1',
      'Heading 2': 'Encabezado 2',
      'Heading 3': 'Encabezado 3',
      'Heading 4': 'Encabezado 4',
      'Heading 5': 'Encabezado 5',
      'Heading 6': 'Encabezado 6',
      'Type your title': 'Introduce tu título',
      'Type or paste your content here.': 'Introduce o pega tu contenido aquí',
      'Font Size': 'Tamaño de fuente',
      Tiny: 'Minúsculo',
      Small: 'Pequeño',
      Big: 'Grande',
      Huge: 'Enorme',
      'Font Family': 'Fuente',
      Default: 'Por defecto',
      'Font Color': 'Color de Fuente',
      'Font Background Color': 'Color de Fondo',
      'Document colors': 'Colores del documento',
      'Find and replace': 'Buscar y reemplazar',
      'Find in text…': 'Buscar en el texto...',
      Find: 'Buscar',
      'Previous result': 'Resultado anterior',
      'Next result': 'Siguiente resultado',
      Replace: 'Reemplazar',
      'Replace all': 'Reemplazar todo',
      'Match case': 'Respetar mayúsculas y minúsculas',
      'Whole words only': 'Solo palabras completas',
      'Replace with…': 'Reemplazar con...',
      'Text to find must not be empty.':
        'El texto a buscar no debe estar vacío.',
      'Tip: Find some text first in order to replace it.':
        'Consejo: Primero busque algún texto para reemplazar.',
      'Advanced options': 'Opciones avanzadas',
      'Find in the document': 'Busca en el documento',
      'Insert a soft break (a <code>&lt;br&gt;</code> element)':
        'Inserta un salto de línea (un elemento <code>&lt;br&gt;</code>)',
      'Insert a hard break (a new paragraph)':
        'Inserta un salto de párrafo (un nuevo párrafo)',
      Cancel: 'Cancelar',
      Clear: 'Borrar',
      'Remove color': 'Quitar color',
      'Restore default': 'Restaurar valores predeterminados',
      Save: 'Guardar',
      'Show more items': 'Mostrar más elementos',
      '%0 of %1': '%0 de %1',
      'Cannot upload file:': 'No se pudo cargar el archivo:',
      'Rich Text Editor. Editing area: %0':
        'Editor de texto enriquecido. Área de edición: %0',
      'Insert with file manager': 'Insertar con administrador de archivos',
      'Replace with file manager': 'Reemplazar con administrador de archivos',
      'Insert image with file manager':
        'Insertar imagen con administrador de archivos',
      'Replace image with file manager':
        'Reemplazar imagen con administrador de archivos',
      File: 'Archivo',
      'With file manager': 'Con el administrador de archivos',
      'Toggle caption off': 'Desactivar título',
      'Toggle caption on': 'Activar título',
      'Content editing keystrokes': 'Teclas de edición de contenido',
      'These keyboard shortcuts allow for quick access to content editing features.':
        'Estos atajos de teclado permiten acceder rápidamente a las funciones de edición de contenido.',
      'User interface and content navigation keystrokes':
        'Teclas de navegación de contenido e interfaz de usuario',
      'Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.':
        'Utilice las siguientes combinaciones de teclas para una navegación más eficiente en la interfaz de usuario de CKEditor 5.',
      'Close contextual balloons, dropdowns, and dialogs':
        'Cierra globos contextuales, menús desplegables y cuadros de diálogo',
      'Open the accessibility help dialog':
        'Abre el cuadro de diálogo de ayuda de accesibilidad',
      'Move focus between form fields (inputs, buttons, etc.)':
        'Mueve el foco entre campos de formulario (entradas, botones, etc.)',
      'Move focus to the menu bar, navigate between menu bars':
        'Mover el foco a la barra de menú, navegar entre las barras de menú',
      'Move focus to the toolbar, navigate between toolbars':
        'Mueve el foco a la barra de herramientas y navega entre barras de herramientas',
      'Navigate through the toolbar or menu bar':
        'Navegar por la barra de herramientas o la barra de menú',
      'Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.':
        'Ejecutar el botón actualmente enfocado. Al ejecutar botones que interactúan con el contenido del editor, el foco vuelve al contenido.',
      Accept: 'Aceptar',
      'Insert code block': 'Insertar bloque de código',
      'Plain text': 'Texto plano',
      'Leaving %0 code snippet': 'Abandonando fragmento de código %0',
      'Entering %0 code snippet': 'Ingresando fragmento de código %0',
      'Entering code snippet': 'Ingresando fragmento de código',
      'Leaving code snippet': 'Abandonando fragmento de código',
      'Code block': 'Bloque de código',
      'Copy selected content': 'Copia el contenido seleccionado',
      'Paste content': 'Pega el contenido',
      'Paste content as plain text': 'Pega el contenido como texto sin formato',
      'Insert image or file': 'Insertar imagen o archivo',
      'Could not obtain resized image URL.':
        'No se pudo obtener el URL de la imagen redimensionada.',
      'Selecting resized image failed':
        'No se pudo seleccionar la imagen redimensionada',
      'Could not insert image at the current position.':
        'No se pudo insertar la imagen en la posición actual.',
      'Inserting image failed': 'Error al insertar la imagen',
      'Open file manager': 'Abrir gestor de archivos',
      'Cannot determine a category for the uploaded file.':
        'No se puede determinar una categoría para el archivo subido.',
      'Cannot access default workspace.':
        'No se puede acceder al espacio de trabajo predeterminado.',
      'Edit image': 'Editar imagen',
      'Processing the edited image.': 'Procesando la imagen editada.',
      'Server failed to process the image.':
        'El servidor no pudo procesar la imagen.',
      'Failed to determine category of edited image.':
        'No se pudo determinar la categoría de la imagen editada.',
      'Block quote': 'Bloque de cita',
      Bold: 'Negrita',
      Italic: 'Cursiva',
      Underline: 'Subrayado',
      Code: 'Código',
      Strikethrough: 'Tachado',
      Subscript: 'Subíndice',
      Superscript: 'Superíndice',
      'Italic text': 'Texto en cursiva',
      'Move out of an inline code style':
        'Sale de un estilo de código en línea',
      'Bold text': 'Texto en negrita',
      'Underline text': 'Subraya el texto',
      'Strikethrough text': 'Tacha el texto',
      'Saving changes': 'Guardando cambios',
      'Revert autoformatting action':
        'Revierte la acción de formato automático',
      'Align left': 'Alinear a la izquierda',
      'Align right': 'Alinear a la derecha',
      'Align center': 'Centrar',
      Justify: 'Justificar',
      'Text alignment': 'Alineación del texto',
      'Text alignment toolbar': 'Barra de herramientas de alineación del texto',
    },
    getPluralForm(n) {
      return n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;
    },
  },
};
